import axios from "axios";

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

const signInClient = axios.create({
  baseURL: `${apiBaseUrl}/auth`,
  withCredentials: true,
});

export default signInClient;
